<template>
  <div>
    <!-- Payment Dialog -->
    <Dialog
      :visible.sync="localPaymentDialog"
      :style="{ width: '500px' }"
      header="Pembayaran"
      :modal="true"
    >
      <div class="p-grid p-col-12">
        <div class="p-col-4">
          <b>TOTAL TAGIHAN</b>
        </div>
        <div class="p-col-8 p-text-right" style="font-size: 26px">
          <b>{{ totalBilledAmount | currency }}</b>
        </div>

        <div class="p-col-12 p-mb-2 p-grid">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Metode Bayar</th>
                <th>Jumlah Bayar</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in paymentTemp" :key="k">
                <td class="p-col-4">
                  <Dropdown
                    v-model="an_item.payment_method_id"
                    :options="paymentMethods"
                    @input="
                      handlePaymentMethodChange(k, an_item.payment_method_id)
                    "
                    optionLabel="name"
                    ref="payment_method"
                    placeholder="Pilih"
                  />
                </td>
                <td class="p-col-5">
                  <InputNumber
                    mode="decimal"
                    :id="'data-price-' + k"
                    placeholder="0"
                    locale="id-ID"
                    v-model="an_item.amount"
                    @focus="handlePaymentFocus(k, $event)"
                    ref="payment"
                    @input="handlePaymentAmountInput(k, $event)"
                    @input-number="handlePaymentAmountInput(k, $event)"
                    :disabled="
                      paymentPay ||
                      !isPaymentMethodCash(an_item.payment_method_id)
                    "
                    :readonly="!isPaymentMethodCash(an_item.payment_method_id)"
                    :class="{ 'p-invalid': isErrorPaymentAmount && k === 0 }"
                  />
                  <Message
                    v-if="isErrorPaymentAmount && k === 0"
                    severity="error"
                    :closable="false"
                    class="p-mt-1 p-mb-0"
                    style="font-size: 0.8125rem; padding: 0.5rem"
                  >
                    <i class="pi pi-exclamation-circle p-mr-1"></i>
                    {{ errorMsgPaymentAmount }}
                  </Message>
                </td>
                <td class="p-col-3">
                  <Button
                    type="button"
                    icon="pi pi-minus"
                    class="p-button-outlined"
                    style="width: 30px; height: 30px"
                    v-if="paymentTemp.length > 1"
                    @click="$emit('remove-payment-method', an_item)"
                  ></Button>
                  <Button
                    type="button"
                    icon="pi pi-plus"
                    class="p-button-outlined"
                    style="width: 30px; height: 30px; margin-left: 0.5rem"
                    v-if="paymentTemp.length == k + 1"
                    @click="$emit('add-payment-method')"
                  ></Button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Total Payment Summary (Always Visible) -->
        <div class="p-col-12 p-mb-2">
          <div class="total-payment-summary-compact">
            <div class="summary-row-compact">
              <span class="summary-label-compact">
                <i class="pi pi-calculator p-mr-1"></i>
                Total Pembayaran
              </span>
              <span class="summary-value-compact">{{
                totalBayar | currency
              }}</span>
            </div>
            <div
              class="summary-row-compact highlight"
              v-if="infaqPaymentAmount > 0"
            >
              <span class="summary-label-compact">
                <i class="pi pi-heart p-mr-1"></i>
                Infaq
              </span>
              <span class="summary-value-compact positive"
                >+ {{ infaqPaymentAmount | currency }}</span
              >
            </div>
            <div
              class="summary-row-compact highlight"
              v-if="roundUpReturnAmount > 0"
            >
              <span class="summary-label-compact">
                <i class="pi pi-arrow-up p-mr-1"></i>
                Pembulatan
              </span>
              <span class="summary-value-compact positive"
                >+ {{ roundUpReturnAmount | currency }}</span
              >
            </div>
          </div>
        </div>

        <div class="p-col-12 p-mb-3 p-grid" style="margin: 0">
          <div class="p-col-6" style="padding: 0 0.5rem 0 0">
            <label for="infaq" class="field-label-compact">
              Infaq
              <i
                class="pi pi-info-circle p-ml-1 info-icon-compact"
                v-tooltip.top="
                  'Infaq dan Pembulatan tidak dapat digunakan bersamaan'
                "
                style="font-size: 0.75rem"
              />
            </label>
            <InputText
              id="infaq"
              v-model="localInfaqAmount"
              type="text"
              placeholder="0"
              :maxlength="4"
              @focus="$event.target.select()"
              :disabled="roundUpReturnAmount != 0 || paymentPay"
              @input="handleInfaqInputChange"
              :class="{ 'p-invalid': isErrorInfaq }"
              class="compact-input"
            />
            <small
              class="p-text-muted p-d-block p-mt-1"
              style="font-size: 0.75rem"
              v-if="roundUpReturnAmount != 0"
            >
              <i class="pi pi-lock p-mr-1"></i>
              Nonaktif karena Pembulatan sudah diisi
            </small>
            <Message
              v-if="isErrorInfaq"
              severity="error"
              :closable="false"
              class="p-mt-1 p-mb-0"
              style="font-size: 0.8125rem; padding: 0.5rem"
            >
              <i class="pi pi-exclamation-circle p-mr-1"></i>
              {{ errorMsgInfaq }}
            </Message>
          </div>
          <div class="p-col-6" style="padding: 0 0 0 0.5rem">
            <label for="pembulatan" class="field-label-compact">
              Pembulatan
              <i
                class="pi pi-info-circle p-ml-1 info-icon-compact"
                v-tooltip.top="
                  'Infaq dan Pembulatan tidak dapat digunakan bersamaan'
                "
                style="font-size: 0.75rem"
              />
            </label>
            <InputText
              id="pembulatan"
              v-model="localRoundUpAmount"
              type="text"
              placeholder="0"
              :maxlength="3"
              :disabled="
                (localInfaqAmount &&
                  localInfaqAmount !== '' &&
                  parseInt(
                    String(localInfaqAmount).replace(/[^\d]/g, ''),
                    10
                  ) !== 0) ||
                paymentPay
              "
              @focus="$event.target.select()"
              @input="handleRoundUpInputChange"
              class="compact-input"
            />
            <small
              class="p-text-muted p-d-block p-mt-1"
              style="font-size: 0.75rem"
              v-if="
                localInfaqAmount &&
                localInfaqAmount !== '' &&
                parseInt(String(localInfaqAmount).replace(/[^\d]/g, ''), 10) !==
                  0
              "
            >
              <i class="pi pi-lock p-mr-1"></i>
              Nonaktif karena Infaq sudah diisi
            </small>
          </div>
        </div>
        <!-- Enhanced Kembalian Display -->
        <div class="p-col-12 p-mt-2" v-if="hasCashPaymentMethod">
          <div
            class="change-display-compact"
            :class="{ insufficient: moneyChanges < 0 }"
          >
            <div class="change-label-compact">
              <i class="pi pi-wallet p-mr-1"></i>
              Kembalian
            </div>
            <div
              class="change-amount-compact"
              :class="{ negative: moneyChanges < 0 }"
            >
              {{ moneyChanges | currency }}
            </div>
            <div class="change-status-compact" v-if="moneyChanges < 0">
              <i class="pi pi-exclamation-triangle p-mr-1"></i>
              Pembayaran kurang
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer">
          <Button
            label="Bayar"
            icon="pi pi-check"
            class="p-button-primary"
            @click="$emit('pay-transaction')"
            v-shortkey="['enter']"
            @shortkey="$emit('pay-transaction')"
            :disabled="
              totalBilledAmount < 0 || isErrorPaymentAmount || loadingPayment
            "
            :loading="loadingPayment"
            style="min-width: 110px"
          >
            <template #loading>
              <i class="pi pi-spin pi-spinner p-mr-2"></i>
              Memproses...
            </template>
          </Button>
        </div>
      </template>
    </Dialog>

    <!-- Change Dialog -->
    <Dialog
      :visible.sync="localChangeDialog"
      :style="{ width: '400px' }"
      header="Transaksi Berhasil"
      :modal="true"
      :closable="false"
    >
      <div class="p-grid p-col-12">
        <div class="p-col-4">
          <b>Kembalian:</b>
        </div>
        <div class="p-col-8 p-text-right" style="font-size: 26px">
          <b>{{ moneyChanges | currency }}</b>
        </div>
      </div>

      <template #footer>
        <Button
          label="OK"
          class="p-button-text"
          @click="$emit('change-reset')"
          v-shortkey="['enter']"
          @shortkey="$emit('change-reset')"
        />
      </template>
    </Dialog>

    <!-- Audit Date Dialog -->
    <Dialog
      :visible.sync="localAuditDateDialog"
      :style="{ width: '500px' }"
      header="WARNING"
      :modal="true"
      :closable="false"
    >
      <div class="p-grid p-col-12 text-center">
        <b style="font-size: 18px"
          >Audit date tidak sesuai, silahkan tutup shift hari ini</b
        ><br />
        <b style="font-size: 18px">dan buka shift kembali</b>
      </div>

      <template #footer>
        <Button
          label="OK"
          class="p-button-text"
          @click="$emit('close-audit-date')"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import Message from 'primevue/message'

export default {
  name: 'POSDialogs',
  components: {
    Message
  },
  props: {
    // Dialog visibility
    showPayment: { type: Boolean, default: false },
    showChange: { type: Boolean, default: false },
    showAuditDate: { type: Boolean, default: false },

    // Payment data
    totalBilledAmount: { type: Number, default: 0 },
    paymentTemp: { type: Array, default: () => [] },
    paymentMethods: { type: Array, default: () => [] },
    paymentPay: { type: Boolean, default: false },
    totalBayar: { type: Number, default: 0 },
    infaqPaymentAmount: { type: [Number, String], default: 0 },
    roundUpReturnAmount: { type: [Number, String], default: 0 },
    moneyChanges: { type: Number, default: 0 },

    // Error states
    isErrorPaymentAmount: { type: Boolean, default: false },
    errorMsgPaymentAmount: { type: String, default: '' },
    isErrorInfaq: { type: Boolean, default: false },
    errorMsgInfaq: { type: String, default: '' },

    // Loading
    loadingPayment: { type: Boolean, default: false }
  },
  data() {
    return {
      localPaymentDialog: this.showPayment,
      localChangeDialog: this.showChange,
      localAuditDateDialog: this.showAuditDate,
      // Store as string initially to preserve user input exactly
      // Conversion to number happens in watcher when emitting to parent
      localInfaqAmount:
        this.infaqPaymentAmount != null && this.infaqPaymentAmount !== ''
          ? String(this.infaqPaymentAmount)
          : '',
      localRoundUpAmount:
        this.roundUpReturnAmount != null && this.roundUpReturnAmount !== ''
          ? String(this.roundUpReturnAmount)
          : ''
    }
  },
  watch: {
    showPayment(newVal) {
      this.localPaymentDialog = newVal
    },
    localPaymentDialog(newVal) {
      this.$emit('update:show-payment', newVal)
      // Focus on first payment amount input when dialog opens
      if (newVal) {
        // When dialog opens, ensure totalBayar is calculated if payment amount is already set
        // This handles the case where payment_temp[0].amount is set before dialog opens
        this.$nextTick(() => {
          // Note: Remaining amount calculation is handled by parent's dialog.payment watcher
          // This ensures proper calculation across all payment methods

          // Check if first payment has an amount but totalBayar is 0
          if (
            this.paymentTemp &&
            this.paymentTemp.length > 0 &&
            this.paymentTemp[0].amount > 0 &&
            this.totalBayar === 0
          ) {
            // Trigger calculation to update totalBayar
            this.$emit('calculate-change', 0)
          }

          this.focusPaymentAmountInput()
          // Attach listeners to all payment inputs for real-time calculation
          if (this.paymentTemp && this.paymentTemp.length > 0) {
            this.paymentTemp.forEach((_, index) => {
              this.attachPaymentInputListener(index)
            })
          }
        })
      } else {
        // Clean up listeners when dialog closes
        this.cleanupPaymentInputListeners()
      }
    },
    showChange(newVal) {
      this.localChangeDialog = newVal
    },
    localChangeDialog(newVal) {
      this.$emit('update:show-change', newVal)
    },
    showAuditDate(newVal) {
      this.localAuditDateDialog = newVal
    },
    localAuditDateDialog(newVal) {
      this.$emit('update:show-audit-date', newVal)
    },
    infaqPaymentAmount(newVal) {
      // Update local value when prop changes from parent
      // Keep as string to preserve exact user input
      if (newVal != null && newVal !== '') {
        this.localInfaqAmount = String(newVal)
      } else {
        this.localInfaqAmount = ''
      }
    },
    localInfaqAmount(newVal) {
      // Convert to number and emit
      // Handle both string and number values
      let numValue = 0
      if (newVal != null && newVal !== '') {
        if (typeof newVal === 'string') {
          // Remove all non-digit characters, then parse as integer
          const cleaned = String(newVal).replace(/[^\d]/g, '')
          numValue = parseInt(cleaned, 10) || 0

          // Debug logging
          if (process.env.NODE_ENV === 'development') {
            console.log('localInfaqAmount watcher:', {
              newVal: newVal,
              type: typeof newVal,
              cleaned: cleaned,
              numValue: numValue
            })
          }
        } else if (typeof newVal === 'number') {
          numValue = parseInt(String(newVal), 10) || 0

          // Debug logging
          if (process.env.NODE_ENV === 'development') {
            console.log('localInfaqAmount watcher (number):', {
              newVal: newVal,
              numValue: numValue
            })
          }
        }
      }

      // Emit the numeric value to parent
      this.$emit('update:infaq-payment-amount', numValue)
    },
    roundUpReturnAmount(newVal) {
      // Update local value when prop changes from parent
      // Keep as string to preserve exact user input
      if (newVal != null && newVal !== '') {
        this.localRoundUpAmount = String(newVal)
      } else {
        this.localRoundUpAmount = ''
      }
    },
    localRoundUpAmount(newVal) {
      // Emit as number
      const numValue =
        typeof newVal === 'string'
          ? parseInt(String(newVal).replace(/[^\d-]/g, ''), 10) || 0
          : Number(newVal) || 0
      this.$emit('update:round-up-return-amount', numValue)
    },
    // Watch paymentTemp prop for real-time calculation
    paymentTemp: {
      handler(newVal, oldVal) {
        // Only process when dialog is visible
        if (!this.localPaymentDialog) return

        if (newVal && oldVal) {
          // Check if array length changed (payment method added/removed)
          if (newVal.length !== oldVal.length) {
            // Attach listeners to new inputs
            this.$nextTick(() => {
              newVal.forEach((_, index) => {
                this.attachPaymentInputListener(index)
              })
            })
            return
          }

          // Find which payment amount changed
          const changedIndex = newVal.findIndex((payment, index) => {
            const oldPayment = oldVal[index]
            if (!oldPayment) return false
            // Compare amounts, handling null/undefined
            const newAmount = payment.amount || 0
            const oldAmount = oldPayment.amount || 0
            return newAmount !== oldAmount
          })

          if (changedIndex >= 0) {
            // Use $nextTick to ensure v-model is fully updated
            this.$nextTick(() => {
              this.$emit('calculate-change', changedIndex)
            })
          }
        }
      },
      deep: true,
      immediate: false
    }
  },
  computed: {
    hasCashPaymentMethod() {
      // Check if any payment method is cash (is_cash = 1)
      if (!this.paymentTemp || this.paymentTemp.length === 0) return false
      return this.paymentTemp.some(
        payment =>
          payment.payment_method_id &&
          this.isPaymentMethodCash(payment.payment_method_id)
      )
    }
  },
  methods: {
    isPaymentMethodCash(paymentMethod) {
      // Check if payment method is cash (is_cash = 1)
      if (!paymentMethod) return false
      // Support both is_cash field and name check for backward compatibility
      if (paymentMethod.is_cash !== undefined) {
        return paymentMethod.is_cash === 1
      }
      // Fallback to name check if is_cash is not available
      return paymentMethod.name === 'CASH'
    },
    handlePaymentMethodChange(index, paymentMethod) {
      // Emit check-payment-method event to parent
      // Parent's checkPaymentMethod() will handle setting the remaining amount
      this.$emit('check-payment-method', index, paymentMethod)
    },
    handleInfaqInputChange(event) {
      // Get the raw value directly from the input element
      const rawValue = event.target ? event.target.value : event

      // Store as string to preserve exact input
      this.localInfaqAmount = rawValue || ''

      // Immediately convert and emit to parent BEFORE calculation
      // This ensures the parent has the updated value when calculate-infaq runs
      let numValue = 0
      if (rawValue != null && rawValue !== '') {
        if (typeof rawValue === 'string') {
          const cleaned = String(rawValue).replace(/[^\d]/g, '')
          numValue = parseInt(cleaned, 10) || 0
        } else {
          numValue = parseInt(String(rawValue), 10) || 0
        }
      }

      // Update parent prop synchronously
      this.$emit('update:infaq-payment-amount', numValue)

      // Use $nextTick to ensure parent prop is updated before calculation
      this.$nextTick(() => {
        // Emit calculate event after parent prop is updated
        this.$emit('calculate-infaq')
      })
    },
    handleRoundUpInputChange(event) {
      // Get the raw value directly from the input element
      const rawValue = event.target ? event.target.value : event

      // Store as string to preserve exact input
      this.localRoundUpAmount = rawValue || ''

      // Immediately convert and emit to parent BEFORE calculation
      let numValue = 0
      if (rawValue != null && rawValue !== '') {
        if (typeof rawValue === 'string') {
          const cleaned = String(rawValue).replace(/[^\d]/g, '')
          numValue = parseInt(cleaned, 10) || 0
        } else {
          numValue = parseInt(String(rawValue), 10) || 0
        }
      }

      // Update parent prop synchronously
      this.$emit('update:round-up-return-amount', numValue)

      // Use $nextTick to ensure parent prop is updated before calculation
      this.$nextTick(() => {
        // Emit calculate event after parent prop is updated
        this.$emit('calculate-round-up')
      })
    },
    handlePaymentFocus(index, event) {
      // Select text on focus
      if (event && event.target) {
        event.target.select()
      }

      // Attach input/keyup listeners to the actual input element for real-time calculation
      // PrimeVue 2.4.2 InputNumber doesn't update v-model on every keystroke
      // We need to access the underlying input element and read value directly
      this.$nextTick(() => {
        this.attachPaymentInputListener(index)
      })
    },
    attachPaymentInputListener(index) {
      const paymentRef = Array.isArray(this.$refs.payment)
        ? this.$refs.payment[index]
        : index === 0
        ? this.$refs.payment
        : null

      if (!paymentRef || !paymentRef.$el) return

      const inputElement = paymentRef.$el.querySelector('input')
      if (!inputElement) return

      // Remove existing listener to avoid duplicates
      const existingHandler = inputElement._paymentInputHandler
      if (existingHandler) {
        inputElement.removeEventListener('keyup', existingHandler)
        inputElement.removeEventListener('input', existingHandler)
        inputElement.removeEventListener('keydown', existingHandler)
      }

      // Create handler that reads value directly from input and triggers calculation
      const handler = e => {
        // Read value directly from input element (before InputNumber formats/validates it)
        const rawValue = e.target.value
        if (
          rawValue !== undefined &&
          rawValue !== '' &&
          this.paymentTemp[index]
        ) {
          // Parse the value (remove formatting like dots, commas from locale)
          const cleaned = String(rawValue)
            .replace(/\./g, '')
            .replace(/,/g, '')
            .trim()
          const numValue = cleaned === '' ? 0 : parseFloat(cleaned) || 0

          // Update the nested property to trigger watcher
          // Note: Modifying nested prop properties is allowed in Vue 2 and triggers reactivity
          if (this.paymentTemp[index].amount !== numValue) {
            this.$set(this.paymentTemp[index], 'amount', numValue)

            // Trigger calculation immediately
            this.$nextTick(() => {
              this.$emit('calculate-change', index)
            })
          }
        } else if (rawValue === '' && this.paymentTemp[index]) {
          // Handle empty input
          if (this.paymentTemp[index].amount !== 0) {
            this.$set(this.paymentTemp[index], 'amount', 0)
            this.$nextTick(() => {
              this.$emit('calculate-change', index)
            })
          }
        }
      }

      // Store handler for cleanup
      inputElement._paymentInputHandler = handler

      // Attach listeners for real-time updates
      inputElement.addEventListener('keyup', handler)
      inputElement.addEventListener('input', handler)
      // Also listen to keydown for immediate feedback (especially for backspace/delete)
      inputElement.addEventListener('keydown', handler)
    },
    handlePaymentAmountInput(index, event) {
      console.log('handlePaymentAmountInput', index, event)
      // Emit calculate-change event for input/input-number events
      // Use $nextTick to ensure v-model is updated first
      this.$nextTick(() => {
        this.$emit('calculate-change', index)
      })
    },
    focusPaymentAmountInput() {
      // Try to focus using refs first
      if (this.$refs.payment) {
        const paymentRefs = Array.isArray(this.$refs.payment)
          ? this.$refs.payment
          : [this.$refs.payment]

        if (paymentRefs.length > 0) {
          const firstPaymentInput = paymentRefs[0]
          if (firstPaymentInput) {
            // PrimeVue InputNumber component - access the input element
            const inputElement =
              (firstPaymentInput.$el &&
                firstPaymentInput.$el.querySelector('input')) ||
              firstPaymentInput.$el
            if (inputElement) {
              setTimeout(() => {
                inputElement.focus()
                inputElement.select()
              }, 100)
              return
            }
          }
        }
      }

      // Fallback: use ID selector
      setTimeout(() => {
        const inputElement = document.getElementById('data-price-0')
        if (inputElement) {
          inputElement.focus()
          inputElement.select()
        }
      }, 100)
    },
    cleanupPaymentInputListeners() {
      // Clean up event listeners from input elements
      if (this.$refs.payment) {
        const paymentRefs = Array.isArray(this.$refs.payment)
          ? this.$refs.payment
          : [this.$refs.payment]

        paymentRefs.forEach(paymentRef => {
          if (paymentRef && paymentRef.$el) {
            const inputElement = paymentRef.$el.querySelector('input')
            if (inputElement && inputElement._paymentInputHandler) {
              inputElement.removeEventListener(
                'keyup',
                inputElement._paymentInputHandler
              )
              inputElement.removeEventListener(
                'input',
                inputElement._paymentInputHandler
              )
              inputElement.removeEventListener(
                'keydown',
                inputElement._paymentInputHandler
              )
              delete inputElement._paymentInputHandler
            }
          }
        })
      }
    }
  },
  beforeDestroy() {
    // Clean up all listeners when component is destroyed
    this.cleanupPaymentInputListeners()
  }
}
</script>

<style scoped>
.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
}

/* Phase 2: Enhanced Visual Hierarchy Styles */

/* Total Payment Summary - Always Visible */
.total-payment-summary-compact {
  background: #f8f9fa;
  border-radius: 6px;
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  font-size: 0.875rem;
}

.total-payment-summary-compact .summary-row-compact {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.375rem 0;
}

.total-payment-summary-compact .summary-row-compact.highlight {
  background: #e7f5ff;
  padding: 0.375rem 0.5rem;
  border-radius: 4px;
  margin: 0.25rem -0.5rem;
}

.total-payment-summary-compact .summary-label-compact {
  font-weight: 600;
  color: #495057;
  display: flex;
  align-items: center;
  font-size: 0.8125rem;
}

.total-payment-summary-compact .summary-value-compact {
  font-weight: 700;
  color: #007bff;
  font-size: 0.9375rem;
}

.total-payment-summary-compact .summary-value-compact.positive {
  color: #28a745;
}

/* Enhanced Kembalian Display */
.change-display-compact {
  background: #f8f9fa;
  border: 2px solid #28a745;
  border-radius: 6px;
  padding: 0.875rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.change-display-compact.insufficient {
  border-color: #dc3545;
  background: #fff5f5;
}

.change-display-compact .change-label-compact {
  font-size: 0.8125rem;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  display: flex;
  align-items: center;
}

.change-display-compact .change-amount-compact {
  font-size: 24px;
  font-weight: 700;
  color: #28a745;
  line-height: 1;
}

.change-display-compact .change-amount-compact.negative {
  color: #dc3545;
}

.change-display-compact .change-status-compact {
  font-size: 0.75rem;
  color: #dc3545;
  font-weight: 600;
  margin-left: auto;
  margin-right: 1rem;
}

/* Field Labels with Tooltips */
.field-label-compact {
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 0.375rem;
  color: #495057;
  font-size: 0.8125rem;
}

.field-label-compact .info-icon-compact {
  color: #6c757d;
  cursor: help;
  transition: color 0.2s;
}

.field-label-compact .info-icon-compact:hover {
  color: #007bff;
}

.compact-input {
  width: 100%;
  font-size: 0.9375rem;
}
</style>
